import React, { useEffect, useState } from "react";
import { Form, Typography } from "antd";
import { useSelector } from "react-redux";
import { useUserBranches } from "../../../hooks/accessControl";
import InputItem from "../../../components/print/formItems/InputItem";
import SignatureItem from "../../../components/print/formItems/SignatureItem";
import DateAndHourItem from "../../../components/print/formItems/DateAndHourItem";
import YesNoItem from "../../../components/print/formItems/YesNoItem";
import FormWrapper from "../../../components/print/Form.style";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import moment from "moment";
import {
  getFullName,
  getProffesionalName,
} from "../../../components/util/helpers";
const { Title, Text } = Typography;
var flatten = require("flat");

const PrintVersion = (props) => {
  const [form] = Form.useForm();
  const activeHouseVisit = useSelector(
    (state) => state.houseVisit.activeHouseVisit
  );
  const userBranches = useUserBranches();
  const [branchName, setBranchName] = useState("");
  const intl = useIntl();
  useEffect(() => {
    if (activeHouseVisit && activeHouseVisit.patient) {
      const branch = userBranches.filter(
        (i) => i.id === activeHouseVisit.patient.branch
      )[0];
      if (branch) {
        setBranchName(branch.name);
      }
    }
  }, [userBranches, activeHouseVisit]);

  const organizationName = useSelector(
    (state) => state.organization.details.name
  );

  useEffect(() => {
    let employeeName =
      activeHouseVisit.planned_employee &&
      getProffesionalName(activeHouseVisit.planned_employee, intl);

    let verifierName =
      activeHouseVisit.verification_signature_owner &&
      getProffesionalName(activeHouseVisit.verification_signature_owner, intl);

    form.setFieldsValue({
      ...flatten(activeHouseVisit, {
        safe: true,
      }),
      date_start: activeHouseVisit.date,
      report_employee_id: employeeName,
      professional_employee_name: verifierName,
      report_duration_minutes: activeHouseVisit
        ? moment(activeHouseVisit.date)
            .add(activeHouseVisit.duration_minutes, "minutes")
            .format()
        : undefined,

      report_date_start: activeHouseVisit ? activeHouseVisit.date : "",
      patient_name: activeHouseVisit.patient
        ? getFullName(
            activeHouseVisit.patient.surename,
            activeHouseVisit.patient.first_name
          )
        : "",
      patient_address: activeHouseVisit.patient
        ? activeHouseVisit.patient.address.city +
          " " +
          activeHouseVisit.patient.address.street +
          " " +
          activeHouseVisit.patient.address.house_number
        : "",
    });
  }, [form, activeHouseVisit]);
  return (
    <FormWrapper>
      <Form layout="vertical" form={form} className="formBody">
        <div className="spacerContainer">
          <Text>{`${organizationName} - ${branchName}`}</Text>
        </div>
        <Title level={3}>
          {<FormattedMessage id="app.house_visits_print.title" />}{" "}
          {moment(activeHouseVisit.date).format("MM/YYYY")}
        </Title>
        <div className="borderedSection" style={{ width: "100%" }}>
          <Title level={5}>
            <FormattedMessage id="app.house_visits_print.patient_and_visitor" />
          </Title>
          <div className="rowContainer">
            <InputItem name="patient_name" category="house_visits_print" />
            <div className="seperator" />
            <InputItem
              name="patient.local_id_number"
              category="house_visits_print"
            />
            <div className="seperator" />
            <InputItem name="patient_address" category="house_visits_print" />
            <div className="seperator" />
            <InputItem
              name="patient.contact_info.phone_number"
              category="house_visits_print"
              phone={true}
            />
            <div className="seperator" />
            <YesNoItem
              name="patient.live_alone"
              category="house_visits_print"
            />
          </div>

          <div className="rowContainer">
            <InputItem
              name="report_employee_id"
              category="house_visits_print"
            />

            <div className="seperator" />
            <DateAndHourItem
              name="date"
              format="date"
              category="house_visits_print"
            />
            <div className="seperator" />

            <DateAndHourItem
              name="report_date_start"
              category="house_visits_print"
            />
            <div className="seperator" />

            <DateAndHourItem
              name="report_duration_minutes"
              category="house_visits_print"
            />
          </div>
        </div>

        <div className="borderedSection" style={{ width: "100%" }}>
          <Title level={5}>
            <FormattedMessage id="app.house_visits_print.general" />
          </Title>

          <div className="rowContainer">
            <YesNoItem
              name="care_giver_was_presented"
              category="house_visits_print"
            />
            <div className="seperator" />
            <YesNoItem
              name="report.time_mathed_planning"
              category="house_visits_print"
            />
            <div className="seperator" />

            <InputItem
              name="report.other_participants"
              category="house_visits_print"
              vertical={true}
            />
            <div className="seperator" />

            <InputItem
              name="report.care_giver_absence_reason"
              category="house_visits_print"
              vertical={true}
            />
          </div>
        </div>

        <div className="borderedSection" style={{ width: "100%" }}>
          <Title level={5}>
            <FormattedMessage id="app.house_visits_print.patientCondition" />
          </Title>

          <InputItem
            name="report.appearances"
            category="house_visits_print"
            vertical={true}
          />
          <InputItem
            name="report.nutritional_status"
            category="house_visits_print"
            vertical={true}
          />

          <InputItem
            name="report.significant_events"
            category="house_visits_print"
            vertical={true}
          />
        </div>

        <div className="borderedSection" style={{ width: "100%" }}>
          <Title level={5}>
            <FormattedMessage id="app.house_visits_print.apartmentCondition" />
          </Title>

          <InputItem
            name="report.apartment_status"
            category="house_visits_print"
            vertical={true}
          />
        </div>

        <div className="borderedSection" style={{ width: "100%" }}>
          <Title level={5}>
            <FormattedMessage id="app.house_visits_print.satisfaction" />
          </Title>

          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ width: "50%" }}>
              <InputItem
                name="report.satisfaction_feedback"
                category="house_visits_print"
                vertical={true}
              />
            </div>

            <div style={{ width: "50%" }}>
              <InputItem
                name="report.plan_hours_feedback"
                category="house_visits_print"
                vertical={true}
              />
            </div>
          </div>

          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ width: "50%" }}>
              <InputItem
                name="report.complains_feedback"
                category="house_visits_print"
                vertical={true}
              />
            </div>

            <div style={{ width: "50%" }}>
              <InputItem
                name="report.requests_feedback"
                category="house_visits_print"
                vertical={true}
              />
            </div>
          </div>
        </div>

        <div className="borderedSection" style={{ width: "100%" }}>
          <Title level={5}>
            <FormattedMessage id="app.house_visits_print.summary" />
          </Title>
          <InputItem
            name="report.summary_and_recommendations"
            category="house_visits_print"
            inline={true}
          />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="rowContainer" style={{ width: "40%" }}>
              <InputItem
                name="report_employee_id"
                category="house_visits_print"
                inline={true}
                border={true}
              />

              <div className="seperator" />
              <SignatureItem
                name="signature"
                category="house_visits_print"
                url={
                  activeHouseVisit.approval_signature &&
                  activeHouseVisit.approval_signature.url
                }
              />
            </div>
            <div className="seperator" style={{ width: "5%" }} />

            {activeHouseVisit.planned_employee &&
            activeHouseVisit.planned_employee.professional_role_id === 3 ? (
              <div className="rowContainer" style={{ width: "55%" }}>
                <InputItem
                  name="professional_employee_name"
                  category="house_visits_print"
                  inline={true}
                  border={true}
                />
                <div className="seperator" />
                <SignatureItem
                  name="signature"
                  category="house_visits_print"
                  url={
                    activeHouseVisit.verification_signature &&
                    activeHouseVisit.verification_signature.url
                  }
                />
              </div>
            ) : null}
          </div>
        </div>
      </Form>
    </FormWrapper>
  );
};

export default PrintVersion;
